/** Per-embed presentation only. Never writes to a published graph or player session. */
export type InitialWidgetState = 'launcher' | 'pip' | 'side-tab';
export function resolveInitialWidgetState(override: unknown, fallback: unknown): InitialWidgetState {
  const valid = (value: unknown): value is InitialWidgetState => value === 'launcher' || value === 'pip' || value === 'side-tab';
  return valid(override) ? override : valid(fallback) ? fallback : 'pip';
}

const validState = (value: unknown): value is InitialWidgetState => value === 'launcher' || value === 'pip' || value === 'side-tab';

/**
 * 0.15.50: Der geschlossene Berater startet zugeklappt als Lasche. Nur ein ausdrückliches
 * Embed-Attribut (`initial-widget-state`) darf ihn aufgeklappt starten lassen, und auch das
 * nicht bei „Bewegung reduzieren“. Die Journey-Einstellung bestimmt, was nach dem Antippen der
 * Lasche erscheint: Video-Vorschau, kompakter Knopf oder direkt der Player.
 */
export function resolveWidgetStart(override: unknown, fallback: unknown, reducedMotion: boolean): { start: InitialWidgetState; afterTab: 'pip' | 'launcher' | 'open' } {
  const configured = validState(fallback) ? fallback : 'pip';
  const afterTab = configured === 'launcher' ? 'launcher' : configured === 'side-tab' ? 'open' : 'pip';
  const start = reducedMotion ? 'side-tab' : validState(override) ? override : 'side-tab';
  return { start, afterTab };
}

/** Vorschau-Medien des geschlossenen Beraters. Ohne Video und ohne Poster wird nichts angezeigt. */
export function hasLauncherMedia(media: { video?: string; poster?: string }): boolean {
  return Boolean(media.video || media.poster);
}
